import { useState, useRef } from 'react';
import {
  sendEmailOtp, verifyEmailOtp, registerWithEmail, login,
} from '../services/api';
import HanumanHero from '../components/HanumanHero';
import { triggerToast } from '../components/Toast';
import CatalystAuthScreen from './CatalystAuthScreen';

// Build-time auth mode: 'legacy' (custom OTP/JWT) | 'catalyst' (Embedded Auth).
const AUTH_MODE = process.env.REACT_APP_AUTH_MODE || 'legacy';

function haptic() { if (navigator.vibrate) navigator.vibrate(10); }

const isEmailFormat = str => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
const isPhoneFormat = str => /^[+\d\s-]{10,15}$/.test(str.replace(/\s/g, ''));

// ── Translations ───────────────────────────────────────────────────────────
const T = {
  hi: {
    appTitle: 'राम नाम',
    screenSignIn: 'लॉगिन करें',
    screenOtp: 'OTP सत्यापन',
    screenCreate: 'यात्रा शुरू करें',
    identifierPlaceholder: 'ईमेल या मोबाइल नंबर',
    continueBtn: 'प्रवेश करें',
    usePassword: 'पासवर्ड से लॉगिन करें',
    newUserLink: 'नया यात्री? खाता बनाएं',
    passwordPlaceholder: 'आपका पासवर्ड',
    loginBtn: 'लॉगिन करें',
    useOtp: 'OTP से लॉगिन करें',
    goBack: '← वापस जाएं',
    otpVerifyingEmail: 'ईमेल सत्यापित करें',
    otpSent: 'OTP भेजा गया',
    otpCheckAt: 'पर OTP जाँचें',
    verifyBtn: 'सत्यापित करें',
    resendOtp: 'OTP पुनः भेजें',
    resendIn: 'पुनः भेजें',
    firstTimeNote: 'पहली बार? अपना विवरण भरें',
    nameLabel: 'नाम',
    nameRequired: 'आवश्यक',
    namePlaceholder: 'आपका पूरा नाम',
    emailLabel: 'ईमेल',
    emailRequired: 'आवश्यक',
    emailPlaceholder: 'आपका ईमेल',
    phoneLabel: 'मोबाइल',
    phoneHint: 'वैकल्पिक — केवल डेटा के लिए',
    phonePlaceholder: '+91 98765 43210',
    passwordLabel: 'पासवर्ड',
    passwordHint: 'वैकल्पिक — अगली बार के लिए, न्यूनतम 6 अक्षर',
    passwordNewPlaceholder: 'पासवर्ड बनाएं',
    beginJourney: 'यात्रा शुरू करें',
    backToSignIn: '← साइन इन पर वापस',
    guestPlay: 'अतिथि के रूप में खेलें',
    errIdentifier: 'सही ईमेल या मोबाइल नंबर दर्ज करें',
    errAlreadyReg: 'यह ईमेल पहले से पंजीकृत है — साइन इन करें',
    errPassword: 'पासवर्ड दर्ज करें',
    errPasswordEmailOnly: 'पासवर्ड लॉगिन के लिए सही ईमेल दर्ज करें',
    errOtp: '6 अंकों का OTP दर्ज करें',
    errName: 'नाम आवश्यक है',
    errEmail: 'सही ईमेल पता दर्ज करें',
    errPasswordLen: 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए',
  },
  mr: {
    appTitle: 'राम नाम',
    screenSignIn: 'लॉगिन करा',
    screenOtp: 'OTP सत्यापन',
    screenCreate: 'यात्रा सुरू करा',
    identifierPlaceholder: 'ईमेल किंवा मोबाईल नंबर',
    continueBtn: 'पुढे जा',
    usePassword: 'पासवर्डने लॉगिन करा',
    newUserLink: 'नवीन? खाते बनवा',
    passwordPlaceholder: 'तुमचा पासवर्ड',
    loginBtn: 'लॉगिन करा',
    useOtp: 'OTP ने लॉगिन करा',
    goBack: '← मागे जा',
    otpVerifyingEmail: 'ईमेल सत्यापित करा',
    otpSent: 'OTP पाठवला',
    otpCheckAt: 'वर OTP तपासा',
    verifyBtn: 'सत्यापित करा',
    resendOtp: 'OTP पुन्हा पाठवा',
    resendIn: 'पुन्हा पाठवा',
    firstTimeNote: 'पहिल्यांदा? तुमचे तपशील भरा',
    nameLabel: 'नाव',
    nameRequired: 'आवश्यक',
    namePlaceholder: 'तुमचे पूर्ण नाव',
    emailLabel: 'ईमेल',
    emailRequired: 'आवश्यक',
    emailPlaceholder: 'तुमचा ईमेल पत्ता',
    phoneLabel: 'मोबाईल',
    phoneHint: 'पर्यायी — फक्त प्रोफाईलसाठी',
    phonePlaceholder: '+91 98765 43210',
    passwordLabel: 'पासवर्ड',
    passwordHint: 'पर्यायी — पुढील लॉगिनसाठी, किमान 6 अक्षरे',
    passwordNewPlaceholder: 'पासवर्ड बनवा',
    beginJourney: 'यात्रा सुरू करा',
    backToSignIn: '← साइन इनवर परत',
    guestPlay: 'पाहुणे म्हणून खेळा',
    errIdentifier: 'योग्य ईमेल किंवा मोबाईल नंबर प्रविष्ट करा',
    errAlreadyReg: 'हा ईमेल आधीच नोंदणीकृत आहे — साइन इन करा',
    errPassword: 'पासवर्ड प्रविष्ट करा',
    errPasswordEmailOnly: 'पासवर्ड लॉगिनसाठी ईमेल पत्ता द्या',
    errOtp: '6 अंकी OTP प्रविष्ट करा',
    errName: 'नाव आवश्यक आहे',
    errEmail: 'योग्य ईमेल पत्ता प्रविष्ट करा',
    errPasswordLen: 'पासवर्ड किमान 6 अक्षरांचा असावा',
  },
  en: {
    appTitle: 'RamNaam',
    screenSignIn: 'Sign In',
    screenOtp: 'OTP Verification',
    screenCreate: 'Create Account',
    identifierPlaceholder: 'Email or Mobile Number',
    continueBtn: 'Continue',
    usePassword: 'Use Password Instead',
    newUserLink: 'New here? Create Account',
    passwordPlaceholder: 'Your Password',
    loginBtn: 'Login',
    useOtp: 'Use OTP instead',
    goBack: '← Go Back',
    otpVerifyingEmail: 'Verify your email',
    otpSent: 'OTP Sent',
    otpCheckAt: '— check for OTP',
    verifyBtn: 'Verify & Login',
    resendOtp: 'Resend OTP',
    resendIn: 'Resend in',
    firstTimeNote: 'First time? Fill in your details',
    nameLabel: 'Name',
    nameRequired: 'required',
    namePlaceholder: 'Your full name',
    emailLabel: 'Email',
    emailRequired: 'required',
    emailPlaceholder: 'Your email address',
    phoneLabel: 'Mobile',
    phoneHint: 'Optional — stored for your profile only',
    phonePlaceholder: '+91 98765 43210',
    passwordLabel: 'Password',
    passwordHint: 'Optional — for next login, min 6 characters',
    passwordNewPlaceholder: 'Create a password',
    beginJourney: 'Begin Journey',
    backToSignIn: '← Back to Sign In',
    guestPlay: 'Play as Guest',
    errIdentifier: 'Please enter a valid email or mobile number',
    errAlreadyReg: 'Email already registered — please sign in',
    errPassword: 'Enter your password',
    errPasswordEmailOnly: 'Enter a valid email address to use password login',
    errOtp: 'Enter the 6-digit OTP',
    errName: 'Name is required',
    errEmail: 'Please enter a valid email address',
    errPasswordLen: 'Password must be at least 6 characters',
  },
};

// ── Inline styles ──────────────────────────────────────────────────────────
const S = {
  screen: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 20px',
    background: 'radial-gradient(ellipse at 50% 0%, #3D0015 0%, #1a0000 55%, #0D0000 100%)',
    overflowY: 'auto',
  },
  container: {
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
  },
  langRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: -8,
  },
  langCycleBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    padding: '6px 12px',
    background: 'rgba(30,0,0,0.5)',
    border: '1px solid rgba(201,130,26,0.35)',
    borderRadius: 20,
    color: 'rgba(255,248,231,0.7)',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
    backdropFilter: 'blur(8px)',
    WebkitTapHighlightColor: 'transparent',
    letterSpacing: 0.5,
  },
  card: {
    width: '100%',
    background: 'rgba(80, 5, 5, 0.55)',
    border: '1px solid rgba(201,130,26,0.40)',
    borderRadius: 16,
    padding: '24px 20px 20px',
    backdropFilter: 'blur(10px)',
  },
  cardTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 18,
  },
  cardTitle: {
    fontFamily: "'Tiro Devanagari Hindi', serif",
    fontSize: 22,
    color: '#D4AF37',
    lineHeight: 1.3,
  },
  inputWrap: {
    position: 'relative',
    marginBottom: 14,
  },
  iconWrap: {
    position: 'absolute',
    left: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'rgba(201,130,26,0.75)',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    padding: '15px 16px 15px 44px',
    minHeight: 54,
    background: 'rgba(20,0,0,0.55)',
    border: '1px solid rgba(201,130,26,0.35)',
    borderRadius: 12,
    color: '#FFF8E7',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 18,
    outline: 'none',
    caretColor: '#FF6B00',
    WebkitAppearance: 'none',
    boxSizing: 'border-box',
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 6,
  },
  label: {
    fontFamily: "'Mukta', sans-serif",
    fontSize: 15,
    color: 'rgba(255,248,231,0.85)',
    fontWeight: 600,
  },
  labelHint: {
    fontFamily: "'Mukta', sans-serif",
    fontSize: 12,
    color: 'rgba(255,248,231,0.35)',
  },
  btn: {
    width: '100%',
    minHeight: 56,
    background: 'linear-gradient(135deg, #FF6D00 0%, #E65100 100%)',
    border: 'none',
    borderRadius: 12,
    color: '#fff',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 20,
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(230,81,0,0.5)',
    marginBottom: 4,
    WebkitTapHighlightColor: 'transparent',
    letterSpacing: 0.3,
  },
  linkBtn: {
    background: 'none',
    border: 'none',
    color: '#FF6B00',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    padding: '10px 0',
    display: 'block',
    textAlign: 'center',
    width: '100%',
  },
  linkBtnDim: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,248,231,0.35)',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 14,
    cursor: 'pointer',
    padding: '8px 0',
    display: 'block',
    textAlign: 'center',
    width: '100%',
  },
  divider: {
    borderTop: '1px solid rgba(201,130,26,0.2)',
    margin: '4px 0 8px',
  },
  otpRow: {
    display: 'flex',
    gap: 10,
    justifyContent: 'center',
    margin: '16px 0',
  },
  otpBox: {
    width: 46,
    height: 54,
    textAlign: 'center',
    fontSize: 22,
    fontFamily: "'Cinzel Decorative', serif",
    background: 'rgba(20,0,0,0.55)',
    border: '1px solid rgba(201,130,26,0.4)',
    borderRadius: 10,
    color: '#FFF8E7',
    outline: 'none',
    caretColor: '#FF6B00',
  },
  timerText: {
    fontFamily: "'Mukta', sans-serif",
    fontSize: 13,
    color: 'rgba(255,248,231,0.4)',
    textAlign: 'center',
    marginBottom: 8,
  },
  emailHintNote: {
    fontFamily: "'Mukta', sans-serif",
    fontSize: 14,
    color: 'rgba(255,248,231,0.6)',
    textAlign: 'center',
    marginBottom: 4,
    lineHeight: 1.6,
  },
  centerNote: {
    fontFamily: "'Mukta', sans-serif",
    fontSize: 13,
    color: 'rgba(255,248,231,0.45)',
    textAlign: 'center',
    marginBottom: 16,
  },
  guestBtn: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,248,231,0.3)',
    fontFamily: "'Mukta', sans-serif",
    fontSize: 15,
    cursor: 'pointer',
    textAlign: 'center',
    padding: '8px',
    lineHeight: 1.6,
  },
};

// ── Icons ──────────────────────────────────────────────────────────────────
function IconEmail() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}
function IconPhone() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.85a16 16 0 0 0 6.1 6.1l.95-.95a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}
function IconLock() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
function IconUser() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  );
}

const spinnerStyle = {
  width: 24, height: 24,
  border: '3px solid rgba(255,255,255,0.3)',
  borderTop: '3px solid #fff',
  borderRadius: '50%',
  animation: 'spin 0.7s linear infinite',
  margin: '0 auto',
};
function Spinner() { return <div style={spinnerStyle} />; }

// ── Component ──────────────────────────────────────────────────────────────
// Thin wrapper: in catalyst mode render the embedded Catalyst screen; otherwise
// the legacy OTP/password screen below (unchanged). No hooks before the branch.
export default function AuthScreen(props) {
  if (AUTH_MODE === 'catalyst') return <CatalystAuthScreen onGuest={props.onGuest} />;
  return <LegacyAuthScreen {...props} />;
}

function LegacyAuthScreen({ onLogin, onGuest }) {
  // Landing / entry screen is always English, regardless of the app language.
  const lang = 'en';
  const [screen, setScreen]   = useState('identifier-entry');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [identifier, setIdentifier]       = useState('');
  const [emailHint, setEmailHint]         = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [emailOtp, setEmailOtp]           = useState(['', '', '', '', '', '']);
  const emailOtpRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  const [regName, setRegName]             = useState('');
  const [regEmail, setRegEmail]           = useState('');
  const [regPhone, setRegPhone]           = useState('');
  const [regPassword, setRegPassword]     = useState('');
  const [verifyToken, setVerifyToken]     = useState('');
  const [registrationPending, setRegistrationPending] = useState(false);

  const [resendTimer, setResendTimer]     = useState(0);
  const timerRef = useRef(null);

  const i18n = T[lang];

  function goTo(s) { setScreen(s); setMessage(null); }
  function showOtpDeliveryMessage(data) {
    if (data?.delivery_mode === 'console' && data.message) {
      setMessage({ text: data.message, type: 'success' });
    }
  }

  function startResendTimer() {
    if (timerRef.current) clearInterval(timerRef.current);
    setResendTimer(60);
    timerRef.current = setInterval(() => {
      setResendTimer(prev => {
        if (prev <= 1) { clearInterval(timerRef.current); return 0; }
        return prev - 1;
      });
    }, 1000);
  }

  // ── Handlers ───────────────────────────────────────────────────────────

  async function handleSendOtp(e) {
    e.preventDefault();
    const trimmed = identifier.trim();
    if (!trimmed || (!isEmailFormat(trimmed) && !isPhoneFormat(trimmed))) {
      setMessage({ text: i18n.errIdentifier, type: 'error' }); return;
    }
    setLoading(true); setMessage(null);
    try {
      const data = await sendEmailOtp(trimmed);
      const normalizedIdentifier = isEmailFormat(trimmed) ? trimmed.toLowerCase() : trimmed;
      setIdentifier(normalizedIdentifier);
      setEmailHint(data.email_hint || trimmed);
      if (data.phone_not_registered) {
        setRegPhone(trimmed);
        setRegName(''); setRegEmail(''); setRegPassword('');
        goTo('register-new'); return;
      }
      startResendTimer();
      setRegistrationPending(false);
      setEmailOtp(['', '', '', '', '', '']);
      goTo('email-otp');
      showOtpDeliveryMessage(data);
      setTimeout(() => emailOtpRefs[0].current?.focus(), 100);
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  function handleUsePasswordLogin() {
    const trimmed = identifier.trim();
    if (!isEmailFormat(trimmed)) {
      setMessage({ text: i18n.errPasswordEmailOnly, type: 'error' }); return;
    }
    setIdentifier(trimmed.toLowerCase());
    setLoginPassword('');
    goTo('email-login');
  }

  async function handlePasswordLogin(e) {
    e.preventDefault();
    if (!loginPassword) { setMessage({ text: i18n.errPassword, type: 'error' }); return; }
    setLoading(true); setMessage(null);
    try {
      const data = await login({ email: identifier.trim(), password: loginPassword });
      haptic(); onLogin(data.user);
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  function handleUseOtpInstead() {
    setMessage(null);
    setEmailOtp(['', '', '', '', '', '']);
    goTo('email-otp');
    setTimeout(() => emailOtpRefs[0].current?.focus(), 100);
  }

  function handleOtpDigit(i, val) {
    const v = val.replace(/\D/g, '').slice(-1);
    const next = [...emailOtp]; next[i] = v; setEmailOtp(next);
    if (v && i < 5) emailOtpRefs[i + 1].current?.focus();
  }
  function handleOtpKey(i, e) {
    if (e.key === 'Backspace' && !emailOtp[i] && i > 0) emailOtpRefs[i - 1].current?.focus();
  }

  async function handleVerifyOtp(e) {
    e.preventDefault();
    const otp = emailOtp.join('');
    if (otp.length !== 6) { setMessage({ text: i18n.errOtp, type: 'error' }); return; }
    setLoading(true); setMessage(null);
    try {
      if (registrationPending) {
        const verifyData = await verifyEmailOtp(identifier.trim(), otp);
        const data = await registerWithEmail({
          name: regName.trim(),
          email: identifier.trim(),
          phone: regPhone.trim() || undefined,
          password: regPassword || undefined,
          verifyToken: verifyData.verify_token,
        });
        haptic(); setRegistrationPending(false);
        if (timerRef.current) clearInterval(timerRef.current);
        onLogin(data.user);
      } else {
        const data = await verifyEmailOtp(identifier.trim(), otp);
        haptic();
        if (timerRef.current) clearInterval(timerRef.current);
        if (data.is_new_user) {
          setRegName(''); setRegEmail(''); setRegPassword('');
          setVerifyToken(data.verify_token || '');
          goTo('register-email');
        } else { onLogin(data.user); }
      }
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  async function handleResendOtp() {
    if (resendTimer > 0 || loading) return;
    setLoading(true);
    try {
      const data = await sendEmailOtp(identifier.trim());
      setEmailHint(data.email_hint || identifier.trim());
      setEmailOtp(['', '', '', '', '', '']);
      startResendTimer();
      showOtpDeliveryMessage(data);
      setTimeout(() => emailOtpRefs[0].current?.focus(), 100);
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  async function handleDirectRegister(e) {
    e.preventDefault();
    if (!regName.trim()) { setMessage({ text: i18n.errName, type: 'error' }); return; }
    if (!regEmail.trim() || !isEmailFormat(regEmail.trim())) {
      setMessage({ text: i18n.errEmail, type: 'error' }); return;
    }
    if (regPassword && regPassword.length < 6) {
      setMessage({ text: i18n.errPasswordLen, type: 'error' }); return;
    }
    setLoading(true); setMessage(null);
    try {
      const data = await sendEmailOtp(regEmail.trim());
      if (data.is_new_user === false) {
        setMessage({ text: i18n.errAlreadyReg, type: 'error' }); return;
      }
      setIdentifier(regEmail.trim());
      setEmailHint(data.email_hint || regEmail.trim());
      setRegistrationPending(true);
      setEmailOtp(['', '', '', '', '', '']);
      startResendTimer();
      goTo('email-otp');
      showOtpDeliveryMessage(data);
      setTimeout(() => emailOtpRefs[0].current?.focus(), 100);
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  async function handleRegisterAfterOtp(e) {
    e.preventDefault();
    if (!regName.trim()) { setMessage({ text: i18n.errName, type: 'error' }); return; }
    const trimmedId = identifier.trim();
    const enteredPhone = isPhoneFormat(trimmedId) && !isEmailFormat(trimmedId);
    const finalEmail = enteredPhone ? regEmail.trim() : trimmedId;
    const finalPhone = enteredPhone ? trimmedId : regPhone.trim();
    if (enteredPhone && (!finalEmail || !isEmailFormat(finalEmail))) {
      setMessage({ text: i18n.errEmail, type: 'error' }); return;
    }
    if (regPassword && regPassword.length < 6) {
      setMessage({ text: i18n.errPasswordLen, type: 'error' }); return;
    }
    setLoading(true); setMessage(null);
    try {
      const data = await registerWithEmail({
        name: regName.trim(),
        email: finalEmail,
        phone: finalPhone || undefined,
        password: regPassword || undefined,
        verifyToken,
      });
      haptic(); onLogin(data.user);
    } catch (err) { setMessage({ text: err.message, type: 'error' }); }
    finally { setLoading(false); }
  }

  function handleGuest() { haptic(); triggerToast(i18n.guestPlay); onGuest(); }

  // ── Derived ────────────────────────────────────────────────────────────
  const enteredPhone = isPhoneFormat(identifier.trim()) && !isEmailFormat(identifier.trim());

  const SCREEN_TITLES = {
    'identifier-entry': i18n.screenSignIn,
    'email-login':      i18n.screenSignIn,
    'email-otp':        i18n.screenOtp,
    'register-email':   i18n.screenCreate,
    'register-new':     i18n.screenCreate,
  };

  const msgEl = message ? (
    <div style={{
      padding: '12px 16px', borderRadius: 10,
      fontFamily: "'Mukta', sans-serif", fontSize: 14,
      textAlign: 'center', marginBottom: 14,
      background: message.type === 'error' ? 'rgba(220,20,60,0.15)' : 'rgba(76,175,80,0.15)',
      border: `1px solid ${message.type === 'error' ? 'rgba(220,20,60,0.35)' : 'rgba(76,175,80,0.35)'}`,
      color: message.type === 'error' ? '#FF6B8A' : '#81C784',
    }}>
      {message.text}
    </div>
  ) : null;

  return (
    <div style={S.screen}>
      <div style={S.container}>

        {/* Hero */}
        <HanumanHero size={90} />

        {/* App title — single line, font matches language */}
        <div style={{ textAlign: 'center', marginTop: -8 }}>
          <div style={{
            fontFamily: lang === 'en' ? "'Cinzel Decorative', serif" : "'Tiro Devanagari Hindi', serif",
            fontSize: lang === 'en' ? 'clamp(16px, 3.5vw, 22px)' : 'clamp(18px, 4vw, 26px)',
            fontWeight: 700,
            color: '#D4AF37',
            textAlign: 'center',
            letterSpacing: lang === 'en' ? 1 : 0,
            textShadow: '0 2px 8px rgba(212,175,55,0.3)',
          }} translate="no" className="notranslate">
            {i18n.appTitle}
          </div>
        </div>

        {/* Card */}
        <div style={S.card}>
          <div style={S.cardTitleRow}>
            <span style={{
              ...S.cardTitle,
              fontFamily: lang === 'en' ? "'Mukta', sans-serif" : "'Tiro Devanagari Hindi', serif",
              fontSize: lang === 'en' ? 20 : 22,
              fontWeight: lang === 'en' ? 700 : 400,
            }}>
              {SCREEN_TITLES[screen]}
            </span>
          </div>

          {msgEl}

          {/* ── Sign In entry ─────────────────────────────── */}
          {screen === 'identifier-entry' && (
            <form onSubmit={handleSendOtp}>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconEmail /></span>
                <input style={S.input} type="text" inputMode="email"
                  placeholder={i18n.identifierPlaceholder}
                  autoComplete="username"
                  value={identifier} onChange={e => setIdentifier(e.target.value)} required />
              </div>
              <button type="submit" style={S.btn} disabled={loading}>
                {loading ? <Spinner /> : i18n.continueBtn}
              </button>
              <button type="button" style={S.linkBtn} onClick={handleUsePasswordLogin}>
                {i18n.usePassword}
              </button>
              <div style={S.divider} />
              <button type="button" style={S.linkBtn}
                onClick={() => { setRegName(''); setRegEmail(''); setRegPhone(''); setRegPassword(''); goTo('register-new'); }}>
                {i18n.newUserLink}
              </button>
            </form>
          )}

          {/* ── Password login ────────────────────────────── */}
          {screen === 'email-login' && (
            <form onSubmit={handlePasswordLogin}>
              <div style={S.centerNote}>{identifier}</div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconLock /></span>
                <input style={S.input} type="password"
                  placeholder={i18n.passwordPlaceholder}
                  autoComplete="current-password"
                  value={loginPassword} onChange={e => setLoginPassword(e.target.value)}
                  required autoFocus />
              </div>
              <button type="submit" style={S.btn} disabled={loading}>
                {loading ? <Spinner /> : i18n.loginBtn}
              </button>
              <div style={S.divider} />
              <button type="button" style={S.linkBtn} onClick={handleUseOtpInstead}>
                {i18n.useOtp}
              </button>
              <button type="button" style={S.linkBtnDim} onClick={() => goTo('identifier-entry')}>
                {i18n.goBack}
              </button>
            </form>
          )}

          {/* ── OTP verification ──────────────────────────── */}
          {screen === 'email-otp' && (
            <form onSubmit={handleVerifyOtp}>
              <div style={S.emailHintNote}>
                {registrationPending ? i18n.otpVerifyingEmail : i18n.otpSent}
                <br />
                <span style={{ color: '#D4AF37', fontWeight: 700, fontSize: 15 }}>{emailHint}</span>
                {' '}{i18n.otpCheckAt}
              </div>
              <div style={S.otpRow}>
                {emailOtp.map((d, i) => (
                  <input key={i} ref={emailOtpRefs[i]}
                    type="text" inputMode="numeric" maxLength={1}
                    value={d} style={S.otpBox}
                    onChange={e => handleOtpDigit(i, e.target.value)}
                    onKeyDown={e => handleOtpKey(i, e)} />
                ))}
              </div>
              {resendTimer > 0 && (
                <div style={S.timerText}>{i18n.resendIn} {resendTimer}s</div>
              )}
              <button type="submit" style={S.btn} disabled={loading}>
                {loading ? <Spinner /> : i18n.verifyBtn}
              </button>
              <button type="button"
                style={{ ...S.linkBtn, opacity: resendTimer > 0 ? 0.4 : 1 }}
                onClick={handleResendOtp} disabled={resendTimer > 0 || loading}>
                {resendTimer > 0 ? `${i18n.resendIn} (${resendTimer}s)` : i18n.resendOtp}
              </button>
              <button type="button" style={S.linkBtnDim} onClick={() => {
                setRegistrationPending(false);
                goTo(registrationPending ? 'register-new' : 'identifier-entry');
              }}>
                {i18n.goBack}
              </button>
            </form>
          )}

          {/* ── Register after OTP (new email user) ──────── */}
          {screen === 'register-email' && (
            <form onSubmit={handleRegisterAfterOtp}>
              <div style={S.centerNote}>{i18n.firstTimeNote}</div>

              <div style={S.labelRow}>
                <span style={S.label}>{i18n.nameLabel}</span>
                <span style={S.labelHint}>{i18n.nameRequired}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconUser /></span>
                <input style={S.input} type="text" placeholder={i18n.namePlaceholder}
                  autoComplete="name" value={regName}
                  onChange={e => setRegName(e.target.value)} required />
              </div>

              {enteredPhone ? (
                <>
                  <div style={S.labelRow}>
                    <span style={S.label}>{i18n.emailLabel}</span>
                    <span style={S.labelHint}>{i18n.emailRequired}</span>
                  </div>
                  <div style={S.inputWrap}>
                    <span style={S.iconWrap}><IconEmail /></span>
                    <input style={S.input} type="email" placeholder={i18n.emailPlaceholder}
                      autoComplete="email" value={regEmail}
                      onChange={e => setRegEmail(e.target.value)} required />
                  </div>
                </>
              ) : (
                <>
                  <div style={S.labelRow}>
                    <span style={S.label}>{i18n.phoneLabel}</span>
                    <span style={S.labelHint}>{i18n.phoneHint}</span>
                  </div>
                  <div style={S.inputWrap}>
                    <span style={S.iconWrap}><IconPhone /></span>
                    <input style={S.input} type="tel" placeholder={i18n.phonePlaceholder}
                      autoComplete="tel" value={regPhone}
                      onChange={e => setRegPhone(e.target.value)} />
                  </div>
                </>
              )}

              <div style={S.labelRow}>
                <span style={S.label}>{i18n.passwordLabel}</span>
                <span style={S.labelHint}>{i18n.passwordHint}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconLock /></span>
                <input style={S.input} type="password" placeholder={i18n.passwordNewPlaceholder}
                  autoComplete="new-password" value={regPassword}
                  onChange={e => setRegPassword(e.target.value)} />
              </div>

              <button type="submit" style={S.btn} disabled={loading}>
                {loading ? <Spinner /> : i18n.beginJourney}
              </button>
            </form>
          )}

          {/* ── Direct register (new user from entry screen) ─ */}
          {screen === 'register-new' && (
            <form onSubmit={handleDirectRegister}>
              <div style={S.labelRow}>
                <span style={S.label}>{i18n.nameLabel}</span>
                <span style={S.labelHint}>{i18n.nameRequired}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconUser /></span>
                <input style={S.input} type="text" placeholder={i18n.namePlaceholder}
                  autoComplete="name" value={regName}
                  onChange={e => setRegName(e.target.value)} required autoFocus />
              </div>

              <div style={S.labelRow}>
                <span style={S.label}>{i18n.emailLabel}</span>
                <span style={S.labelHint}>{i18n.emailRequired}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconEmail /></span>
                <input style={S.input} type="email" placeholder={i18n.emailPlaceholder}
                  autoComplete="email" value={regEmail}
                  onChange={e => setRegEmail(e.target.value)} required />
              </div>

              <div style={S.labelRow}>
                <span style={S.label}>{i18n.phoneLabel}</span>
                <span style={S.labelHint}>{i18n.phoneHint}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconPhone /></span>
                <input style={S.input} type="tel" placeholder={i18n.phonePlaceholder}
                  autoComplete="tel" value={regPhone}
                  onChange={e => setRegPhone(e.target.value)} />
              </div>

              <div style={S.labelRow}>
                <span style={S.label}>{i18n.passwordLabel}</span>
                <span style={S.labelHint}>{i18n.passwordHint}</span>
              </div>
              <div style={S.inputWrap}>
                <span style={S.iconWrap}><IconLock /></span>
                <input style={S.input} type="password" placeholder={i18n.passwordNewPlaceholder}
                  autoComplete="new-password" value={regPassword}
                  onChange={e => setRegPassword(e.target.value)} />
              </div>

              <button type="submit" style={S.btn} disabled={loading}>
                {loading ? <Spinner /> : i18n.beginJourney}
              </button>
              <button type="button" style={S.linkBtnDim} onClick={() => goTo('identifier-entry')}>
                {i18n.backToSignIn}
              </button>
            </form>
          )}

        </div>{/* /card */}

        <button style={S.guestBtn} onClick={handleGuest}>
          {i18n.guestPlay}
        </button>

      </div>
    </div>
  );
}
